import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, of, ReplaySubject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {DEREGISTRATION_PACK_STATUS_SENT, DictService} from '../../../shared/services/dict.service';
import {delay, first, takeUntil, tap} from 'rxjs/operators';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {DeregistrationPack} from '../../../shared/interface/deregistration-pack';
import {DeregistrationPackService} from '../../../shared/services/deregistration-pack.service';

@Component({
  selector: 'app-deregistration-pack-add',
  templateUrl: './deregistration-pack-add.component.html',
  styleUrls: ['./deregistration-pack-add.component.scss']
})
export class DeregistrationPackAddComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() deregistrationPack?: Observable<DeregistrationPack>;
  @Output() closeModification = new EventEmitter<any>();

  deregistrationPackObject: DeregistrationPack;
  deregistrationPackForm: FormGroup;
  insuranceCompanyControl: FormControl;
  statusControl: FormControl;
  sentAtControl: FormControl;
  companyControl: FormControl;
  processingRequest = false;
  errors: any = {};

  constructor(
    private deregistrationPackService: DeregistrationPackService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private dictService: DictService,
  ) {
    this.deregistrationPackForm = this.fb.group({
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      company: this.companyControl = fb.control('', [Validators.required]),
      status: this.statusControl = fb.control('', [Validators.required]),
      sentAt: this.sentAtControl = fb.control(''),
    });
  }

  ngOnInit(): void {
    if (this.deregistrationPack) {
      this.deregistrationPack
        .pipe(takeUntil(this.destroyed$))
        .subscribe((deregistrationPack: DeregistrationPack) => {
          this.deregistrationPackObject = deregistrationPack;
          this.initialize(deregistrationPack);
        });

      this.statusControl.valueChanges
        .pipe(takeUntil(this.destroyed$))
        .subscribe((dictId: number) => {
          this.dictService.getKey(dictId)
            .subscribe((dictKey: string) => {
              if (DEREGISTRATION_PACK_STATUS_SENT === dictKey) {
                this.sentAtControl.setValue(new Date());
              }
            });
        });
      this.insuranceCompanyControl.disable();
      this.companyControl.disable();
    } else {
      this.statusControl.disable();
      this.sentAtControl.disable();
      this.initialized.next(true);
    }
  }

  initialize(deregistrationPack: DeregistrationPack): void {
    of(deregistrationPack)
      .pipe(
        delay(0),
        tap(() => {
          this.deregistrationPackForm.reset({
            status: deregistrationPack.status.id,
            sentAt: deregistrationPack.sentAt
          });
          this.initialized.next(true);
        })
      ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    this.processingRequest = true;
    this.deregistrationPackService.sendForm(
      this.deregistrationPackForm.getRawValue(),
      this.deregistrationPackObject ? this.deregistrationPackObject.uuid : null
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open(this.deregistrationPackObject ? 'Pomyślnie zaktualizowano paczkę' : 'Pomyślnie utworzono paczkę', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        if (this.deregistrationPack) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/wyrejestrowania/szczegoly', response.uuid]);
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.deregistrationPackForm, this.errors);
        }
      });
  }

  cancel(): void {
    if (!this.deregistrationPackObject) {
      this.router.navigate(['/wyrejestrowania']);
    } else {
      this.closeModification.emit();
    }
  }

}
